import { render, staticRenderFns } from "./SettingInfo.vue?vue&type=template&id=075966d9&scoped=true"
import script from "./SettingInfo.vue?vue&type=script&lang=js"
export * from "./SettingInfo.vue?vue&type=script&lang=js"
import style0 from "./SettingInfo.vue?vue&type=style&index=0&id=075966d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075966d9",
  null
  
)

export default component.exports